import React, { useMemo } from 'react'
import { RJSFSchema, WidgetProps } from '@rjsf/utils'
import RadioWidget from '@rjsf/core/lib/components/widgets/RadioWidget'
import { defaultFeatureValueSelector } from '../../../../../store/features/selectors'
import { useSelector } from 'react-redux'
import { FeatureName } from '../../../../../store/features/types'

export const RadioWithDefaultWidget: React.FC<WidgetProps> = props => {
  const defaultValue = useSelector(defaultFeatureValueSelector(props.name as FeatureName))

  const enumOptions = useEnumOptions(props.schema, defaultValue)

  return <RadioWidget {...props} schema={props.schema} options={{ enumOptions }} />
}

function useEnumOptions(schema: RJSFSchema, defaultValue: any) {
  return useMemo(() => {
    switch (schema.type) {
      case 'boolean':
        return [
          { value: undefined, label: `Auto (${defaultValue ? 'ON' : 'OFF'})` },
          { value: true, label: 'ON' },
          { value: false, label: 'OFF' }
        ]
      case 'string':
        if (!schema.enum) {
          return [{ value: undefined, label: 'Something is broken :(' }]
        }

        const nativeOptions = Object.values(schema.enum).map((value, idx) => ({
          value,
          label: String(schema.enumNames?.[idx] ?? value).toUpperCase()
        }))

        return [
          { value: undefined, label: `Auto (${String(defaultValue).toUpperCase()})` },
          ...nativeOptions
        ]

      default:
        return []
    }
  }, [defaultValue, schema.enum, schema.enumNames, schema.type])
}
